const enUS = {
  'modal.close': 'Close',
  'session_expired.title': 'The session has expired',
  'tokenizationForm.payment-terms.text1': 'I authorize Flywire to store and charge my debit/credit card automatically on behalf of {{recipientName}}. I have read, understand, and agree to',
  'tokenizationForm.general-terms.link2': 'Privacy Policy',
  'tokenizationForm.general-terms.link-joint': ' and ',
  'tokenizationForm.general-terms.link1': 'Terms of Use',
  'tokenizationForm.payment-terms.link': 'Flywire\'s Terms of Use for automated payments',
  'tokenizationForm.labels.cvvTooltip': '3 digits in the back of your card or 4 digits in the front',
  'tokenizationForm.labels.cvv': 'CVV',
  'tokenizationForm.labels.expiryDate': 'Expiry date (MM/YY)',
  'tokenizationForm.labels.cardNumber': 'Card number',
  'tokenizationForm.labels.phone': 'Phone number',
  'tokenizationForm.labels.upopPhone': 'Please enter the mobile number linked to this bank card',
  'tokenizationForm.labels.zip': 'Zip code',
  'tokenizationForm.labels.address': 'Address',
  'cardsForm.labels.state': 'State',
  'tokenizationForm.labels.country': 'Country or region',
  'tokenizationForm.labels.city': 'City',
  'tokenizationForm.labels.email': 'Email',
  'tokenizationForm.labels.lastName': 'Last name',
  'tokenizationForm.labels.firstName': 'First name',
  'cardsForm.title': 'Cardholder information',
  'success.title': 'Your funds are on the way',
  'success.title.info': 'Please allow 2-3 business days for the funds to arrive.\nYou will receive an email when the funds are delivered.',
  'bankAccountForm.hints.generic': 'Example: {{label}}',
  'bankAccountForm.hints.account_number': 'Account number length must be between 1 and 17 characters',
  'bankAccountForm.hints.routing_number': 'Routing number length must be 9 digits',
  'bankAccountForm.labels.accountZipCode': 'Post code',
  'bankAccountForm.labels.accountIban': 'IBAN',
  'bankAccountForm.labels.accountBicCode': 'BIC code',
  'bankAccountForm.labels.accountNumber': 'Account number',
  'bankAccountForm.labels.accountSortCode': 'Sort code',
  'bankAccountForm.labels.accountRoutingNumber': 'Routing number',
  'bankAccountForm.labels.accountType': 'Account type',
  'bankAccountForm.labels.eftProviderWidnow': 'You will be taken to the partner\'s processing platform to complete this payment. Once it is done, you will be redirected to this page again',
  'bankAccountForm.labels.termsFlywire': 'I have read, understand, and agree to the Flywire\'s <a class=\'fw-underline fw-text-primary-600\' href=\'https://www.flywire.com/terms/\' target=\'_blank\' rel=\'noopener noreferrer\' data-testid=\'termsOfUseLink\'>Terms of Use</a> and <a class=\'fw-underline fw-text-primary-600\' href=\'https://www.flywire.com/privacy/\' target=\'_blank\' data-testid=\'privacyPolicyLink\' rel=\'noopener noreferrer\'>Privacy Policy</a>',
  'bankAccountForm.labels.termsDirectDebit': 'I confirm I am the account owner of this account and the only one signatory required to authorize this direct debit',
  'bankAccountForm.labels.termsEft': 'I have read, understand, and agree to the <a class=\'fw-underline fw-text-primary-600\' href=\'https://opu.myonplanu.com/pdf/pad-agreement.pdf\' target=\'_blank\' rel=\'noopener noreferrer\'>Pre-Authorized Debit Agreement</a>',
  'bankAccountForm.labels.city': 'City',
  'bankAccountForm.labels.country': 'Country or region',
  'bankAccountForm.labels.selectCountry': 'Select a country or region',
  'bankAccountForm.title': 'Accountholder information',
  'failure.tryAgain': 'Try again',
  'failure.title': 'Transaction failed',
  'failure.connectivity.message': 'The operation failed, this could be due to some connectivity issues.',
  'failure.message': 'The transaction failed. This could be due to connectivity issues. Please try again. If the problem persists, please try another payment method or contact your bank',
  'sessionExpired.text': 'The session has expired',
  'LoadingError.title': 'Something went wrong',
  'LoadingError.message': 'There was an error loading the form',
  'tokenizationForm.errors.noPaymentOptionsAvailable': 'There are no payment options available for the selected country/region',
  'offerError.noOptions.card': 'The selected card type is not supported. Please use a different card type.',
  'offerError.noOptions.bank': 'The selected bank account is not supported. Please use a different bank account.',
  'offerError.noOptions.other': 'The selected Payment Method is not supported. Please use a different Payment Method.',
  'bankAccountForm.labels.accountHolderType.personal': 'Personal Account',
  'bankAccountForm.labels.accountHolderType.business': 'Business Account',
  'bankAccountForm.labels.name': 'First name',
  'bankAccountForm.labels.businessName': 'Business name',
  'bankAccountForm.labels.surname': 'Last name',
  'bankAccountForm.labels.phone': 'Phone number',
  'bankAccountForm.labels.email': 'Email',
  'bankAccountForm.labels.zip': 'Zip code',
  'bankAccountForm.labels.accountAddress': 'Address',
  'bankAccountForm.labels.address': 'Address',
  'bankAccountForm.errors.dynamicFields': 'Invalid {{field}}',
  'bankAccountForm.labels.saveButton': 'Save',
  'bankAccountForm.labels.nextButton': 'Next',
  'bankAccountForm.labels.payButton': 'Pay',
  'bankAccountForm.errors.cardNumber': 'Invalid card number',
  'tokenizationForm.errors.cardNumber': 'Invalid card number',
  'tokenizationForm.errors.cvv': 'Invalid CVV Number',
  'bankAccountForm.errors.cvv': 'Invalid CVV Number',
  'tokenizationForm.errors.unsupportedCardTypes': 'Only {{acceptedCardsList}} are supported',
  'tokenizationForm.errors.unsupportedCardType': 'Only {{acceptedCard}} is supported',
  'tokenizationForm.errors.cardType.and': 'and',
  'tokenizationForm.errors.name': 'Invalid first name',
  'tokenizationForm.errors.email': 'Invalid email',
  'tokenizationForm.errors.country': 'Invalid country or region',
  'tokenizationForm.errors.state': 'Invalid state',
  'tokenizationForm.errors.city': 'Invalid city',
  'tokenizationForm.errors.address': 'Invalid address',
  'tokenizationForm.errors.addressIsPoBox': 'We do not accept PO Boxes in the address field.',
  'tokenizationForm.errors.onlyLetterOrNumbers': 'Valid characters include A-Z and 0-9 only',
  'tokenizationForm.errors.onlyLetterOrNumbersOrSymbol': 'Valid characters include A-Z, 0-9 and "/, -" only',
  'tokenizationForm.errors.zip': 'Invalid zip',
  'tokenizationForm.errors.expiryDate': 'Invalid expiration date',
  'bankAccountForm.errors.expiryDate': 'Invalid expiration date',
  'tokenizationForm.errors.surname': 'Invalid family name',
  'tokenizationForm.errors.phone': 'Invalid phone number',
  'tokenizationForm.errors.length': 'Field is too long (maximum is 256 characters)',
  'tokenizationForm.errors.required.field': 'Required field',
  'bankAccountForm.errors.name': 'Invalid first name',
  'bankAccountForm.errors.name.maxSizeExceeded': 'First name is too long (maximum is 140 characters)',
  'form.errors.name.maxSizeExceeded': 'First name is too long (maximum is {{limit}} characters)',
  'form.errors.surname.maxSizeExceeded': 'Last name is too long (maximum is {{limit}} characters)',
  'form.errors.business_name.maxSizeExceeded': 'Business name is too long (maximum is {{limit}} characters)',
  'form.errors.city.maxSizeExceeded': 'City is too long (maximum is {{limit}} characters)',
  'form.errors.address.maxSizeExceeded': 'Address is too long (maximum is {{limit}} characters)',
  'form.errors.date.wrongDate': 'Invalid date picker value',
  'bankAccountForm.errors.business_name': 'Invalid business name',
  'bankAccountForm.errors.business_name.maxSizeExceeded': 'Business name is too long (maximum is 140 characters)',
  'bankAccountForm.errors.surname': 'Invalid last name',
  'bankAccountForm.errors.surname.maxSizeExceeded': 'Last name is too long (maximum is 140 characters)',
  'bankAccountForm.errors.country': 'Invalid country or region',
  'bankAccountForm.errors.address': 'Invalid address',
  'bankAccountForm.errors.address.maxSizeExceeded': 'Address is too long (maximum is 256 characters)',
  'bankAccountForm.errors.city': 'Invalid city',
  'bankAccountForm.errors.city.maxSizeExceeded': 'City is too long (maximum is 256 characters)',
  'bankAccountForm.errors.email': 'Invalid email',
  'bankAccountForm.errors.state': 'Invalid state',
  'bankAccountForm.errors.iban': 'Invalid IBAN',
  'bankAccountForm.errors.bic': 'Invalid BIC code',
  'bankAccountForm.errors.accountnumber': 'Invalid Account number',
  'bankAccountForm.errors.sortcode': 'Invalid Sort code',
  'bankAccountForm.errors.account_type': 'Invalid Account type',
  'bankAccountForm.errors.addressIsPoBox': 'We do not accept PO Boxes in the address field.',
  'bankAccountForm.errors.onlyLetterOrNumbers': 'Valid characters include A-Z and 0-9 only',
  'bankAccountForm.errors.onlyLetterOrNumberOrSymbol': 'Valid characters are: A-Z 0-9 / , -',
  'bankAccountForm.errors.zip': 'Invalid post code',
  'bankAccountForm.errors.phone': 'Invalid phone number',
  'bankAccountForm.errors.ach_account_number': 'Invalid Account number',
  'bankAccountForm.errors.routing_number': 'Invalid Routing number',
  'bankAccountForm.errors.offer': 'No payment options available - If you have a bank account in another country/region, please select this country/region or pick another card and try again. If this does not solve the problem, please contact {{recipientName}}',
  'binLookUp.unableToFindCard.message': 'Card error. Review the card details you entered or try a different card.',
  'binLookUp.warning.message': 'We cannot verify your card',
  'confirmationPage.labels.edit': 'Edit',
  'confirmationPage.labels.confirm': 'Confirm',
  'confirmationPage.labels.title': 'Review mandate info',
  'confirmationPage.labels.typeOfPayment': 'Type of payment',
  'confirmationPage.labels.paymentRecipient': 'Payment recipient',
  'confirmationPage.labels.typeOfPayment.oneOff': 'One-off',
  'confirmationPage.labels.typeOfPayment.recurring': 'Recurring',
  'confirmationPage.labels.directDebitInformation': 'Direct debit information',
  'confirmationPage.labels.directDebitInformation.title': 'Instructions to your bank',
  'confirmationPage.labels.directDebitInformation.creditor': 'Creditor',
  'confirmationPage.labels.directDebitInformation.creditorId': 'Creditor ID',
  'confirmationPage.labels.directDebitInformation.serviceUserStatement': 'Name in your statement',
  'confirmationPage.labels.directDebitInformation.serviceUserId': 'Service user ID',
  'confirmationPage.labels.directDebitInformation.address': 'Flywire address',
  'confirmationPage.labels.directDebitInformation.originator': 'Originator',
  'confirmationPage.labels.directDebitInformation.originatorId': 'Originator ID',
  'confirmationPage.labels.directDebitInformation.originatorAddress': 'Originator address',
  'confirmationPage.labels.bankAccountInformation': 'Bank account information',
  'confirmationPage.labels.bankAccountInformation.name': 'Name',
  'confirmationPage.labels.bankAccountInformation.iban': 'IBAN number',
  'confirmationPage.labels.bankAccountInformation.email': 'Email',
  'confirmationPage.labels.bankAccountInformation.country': 'Country or region',
  'confirmationPage.labels.bankAccountInformation.state': 'State',
  'confirmationPage.labels.bankAccountInformation.city': 'City',
  'confirmationPage.labels.bankAccountInformation.bicCode': 'BIC code',
  'confirmationPage.labels.bankAccountInformation.accountNumber': 'Account number',
  'confirmationPage.labels.bankAccountInformation.sortCode': 'Sort code',
  'confirmationPage.labels.bankAccountInformation.achAccountNumber': 'Account number',
  'confirmationPage.labels.bankAccountInformation.routingNumber': 'Routing number',
  'confirmationPage.labels.bankAccountInformation.accountType': 'Account type',
  'confirmationPage.labels.paymentInformation': 'Payment information',
  'confirmationPage.labels.paymentInformation.amount': 'Amount',
  'confirmationPage.labels.changeAccountEft': 'Change bank account details',
  'confirmationPage.labels.editPayerEft': 'Edit Payer Details',
  'confirmationPage.labels.useAccountEft': 'Use Account ending in **** {{lastFour}}',
  'confirmationPage.labels.bankLinkSuccessMessage': 'Bank account successfully linked',
  'confirmationPage.labels.termsSepa': 'By signing this mandate form, you authorise (A) FLYWIRE EUROPE UAB to send instructions to your bank to debit your account and (B) your bank to debit your account in accordance with the instructions from FLYWIRE EUROPE UAB. You will be notified at least 3 days prior to being charged.',
  'confirmationPage.labels.termsBacs': 'Instruct your bank to pay Flywire Payments Limited Direct Debits from the account detailed in this instruction subject to the safeguards assured by the Direct Debit Guarantee. I understand this instruction may remain with Flywire Payments Limited and, if so, details will be passed electronically to my bank/building society.',
  'confirmationPage.labels.termsAch': '\n     By clicking "Confirm", you affirm that you have proper authority to and hereby authorize Flywire on behalf of the specified recipient\n     ("Payee") to debit the bank account provided by you for any amount owed for charges arising from your use of the Payee\'s services\n     and/or purchase of products from the Payee, and if necessary, to correct erroneous debits, pursuant to the Payee\'s terms, until this\n     authorization is revoked. In the case of an ACH transaction being rejected for insufficient funds I understand that I will be charged an\n     NSF fee, and that Flywire may at its discretion attempt to process the charge again.\n     ',
  'confirmationPage.labels.termsAch2': '\n     If you use or purchase additional products and/or services of the Payee periodically, pursuant to the Payee\'s terms, you authorize\n     Flywire, on behalf of the Payee, to periodically debit the bank account provided by you. Payments that fall outside of the debit\n     authorized above will only be debited after your authorization is obtained via your account, or else a password, code, or other\n     signature equivalent.\n     ',
  'confirmationPage.labels.termsAch3': '\n     You may revoke this authorization at any time by contacting the Payee. Your revocation must be received at least [10 business days]\n     prior to the next scheduled payment.\n    ',
  'confirmationPage.labels.print': 'Print agreement',
  'amountPanel.labels.amountFromLabel': 'You will pay',
  'amountPanel.labels.surchargeFeeInfo': 'card fee included',
  'amountPanel.labels.serviceFeeInfo': 'service fee included',
  'amountPanel.labels.serviceFeePercentageInfo': '{{percentage}} service fee (min. {{minimumFee}})',
  'amountPanel.labels.serviceFeePercentageOnlyInfo': '{{percentage}} service fee',
  'amountPanel.labels.whyThisFee': 'Why this fee?',
  'amountPanel.labels.currencyChangeWarning': 'Currency has changed to match your card currency',
  'amountPanel.labels.amountToLabel': '{{recipientName}} will receive',
  'amountPanel.labels.editCurrencySelection': 'Edit currency selection',
  'amountPanel.labels.discountApplied': '{{amount}} discount applied',
  'currencyInfoBanner.labels.currencyInfo': 'You will be charged in <b>{{code}} ({{symbol}})</b> for your upcoming payments.',
  'currencyInfoBanner.error.offerNotFound': 'No payment options available.',
  'AX': 'Åland Islands',
  'AD': 'Andorra',
  'BG': 'Bulgaria',
  'AT': 'Austria',
  'BE': 'Belgium',
  'HR': 'Croatia',
  'CY': 'Cyprus',
  'CZ': 'Czech Republic',
  'DK': 'Denmark',
  'EE': 'Estonia',
  'FI': 'Finland',
  'FR': 'France',
  'GP': 'Guadeloupe',
  'DE': 'Germany',
  'GR': 'Greece',
  'HU': 'Hungary',
  'IS': 'Iceland',
  'IE': 'Ireland',
  'VA': 'Holy See (Vatican City State)',
  'IT': 'Italy',
  'LI': 'Liechtenstein',
  'LT': 'Lithuania',
  'LU': 'Luxembourg',
  'YT': 'Mayotte',
  'MT': 'Malta',
  'MQ': 'Martinique',
  'ES': 'Spain',
  'NO': 'Norway',
  'NL': 'Netherlands',
  'PL': 'Poland',
  'PT': 'Portugal',
  'SE': 'Sweden',
  'RE': 'Réunion',
  'RO': 'Romania',
  'CH': 'Switzerland',
  'BL': 'Saint Barthélemy',
  'GB': 'United Kingdom',
  'MC': 'Monaco',
  'MF': 'Saint Martin (French part)',
  'PM': 'Saint Pierre and Miquelon',
  'SM': 'San Marino',
  'SK': 'Slovakia',
  'SI': 'Slovenia',
  'GF': 'French Guiana',
  'LV': 'Latvia',
  'CA': 'Canada',
  'US': 'United States',
  'inlineDialogConfirmation.labels.title': 'Confirmation Needed: Cancel Process',
  'inlineDialogConfirmation.labels.body': 'Are you sure you want to cancel this process?',
  'inlineDialogConfirmation.labels.closeButton': 'No',
  'inlineDialogConfirmation.labels.confirmButton': 'Yes',
  'priceBreakDown.price.toggle.button': 'Price Breakdown',
  'priceBreakDown.fx.toggle.button': 'FX Breakdown',
  'priceBreakDown.fees': 'Fees',
  'priceBreakDown.service_fees': 'Service fee',
  'priceBreakDown.card_fees': 'Card fee',
  'priceBreakDown.exchange.rate': 'Exchange rate',
  'priceBreakDown.markup.rate': 'Mark-up from ECB rate',
  'priceBreakDown.discount': 'Discount',
  'priceBreakDown.discount.coupon': 'Discount ({{code}})',
  'priceBreakDown.original_amount': 'Original amount',
  'priceBreakDown.total': 'Total',
  'acceptProposedOfferBanner.textInfo': 'This card is not eligible. Tap \'Accept\' to proceed to supported payment methods or ',
  'acceptProposedOfferBanner.textInfoWithoutChangeCard': 'This card is not eligible. Tap \'Accept\' to proceed to supported payment methods.',
  'acceptProposedOfferBanner.link.option': 'change card',
  'acceptProposedOfferBanner.labels.accept': 'Accept',
  'chooseCurrencyBanner.title': 'Choose currency',
  'chooseCurrencyBanner.message': 'Your card currency differs from your billing country currency. Please select which currency you would like to use for this transaction:',
  'banner.offer.validation.message': 'You have to choose an action to continue.',
  'instructions.offline.amount.label': 'Amount to pay',
  'instructions.offline.reference.label': 'Reference / Payment ID',
  'instructions.offline.paymentId.label': 'Payment ID',
  'instructions.offline.paymentReferenceMissing': 'Payment reference is not present',
  'instructions.offline.missing.title': 'Your payment instructions could not be generated',
  'instructions.offline.missing.message': 'Please try again. If the problem persists, please try another payment method or contact your bank.',
  'instructions.offline.title': 'Payment Instructions',
  'instructions.offline.understand': 'I understand I need to initiate a transfer from my bank.<br />Click here to close.',
  'instructions.offline.download.button': 'Download instructions for the bank transfer',
  'instructions.offline.howToBankTransfer': 'How to make a bank transfer?',
  'instructions.offline.howToBankTransfer.modal.title': 'How to complete your bank transfer',
  'instructions.offline.howToBankTransfer.modal.intro': 'Below are different options you can use to complete your bank transfer:',
  'instructions.offline.howToBankTransfer.modal.onlineBankingTitle': 'Online banking / Mobile banking',
  'instructions.offline.howToBankTransfer.modal.onlineBankingDescription': 'If you have online banking or a mobile app from your bank, you can easily log in to your account and make the transfer yourself.',
  'instructions.offline.howToBankTransfer.modal.inPersonTitle': 'In-person visit to bank branch',
  'instructions.offline.howToBankTransfer.modal.inPersonDescription': 'By paying a personal visit to your local bank branch, you can provide your bank the required account details found in your payment instructions in order to make the transfer.',
  'instructions.offline.howToBankTransfer.modal.telephoneTitle': 'Telephone transfer',
  'instructions.offline.howToBankTransfer.modal.telephoneDescription': 'You may also call your bank and authorize them to initiate the transaction on your behalf.',
  'instructions.offline.referenceWarning': 'You must include this reference so we can identify your payment',
  'instructions.offline.dueDateLabel': 'Transfer the funds before:',
  'instructions.offline.processingTime': 'Flywire will receive the funds: <strong>2-3 business days</strong> after you initiate the transfer',
  'elementsInstructions.qr.description': 'Scan the QR code to complete the payment',
  'elementsInstructions.qr.payid.description': 'Open your banking app and send to the PayID below. This address is assigned exclusively to your account — payments are matched automatically.',
  'elementsInstructions.qr.scan': 'Or scan with your phone camera',
  'elementsInstructions.qr.waitingForPayment': 'Awaiting payment completion',
  'elementsInstructions.externalAction.generic': 'Please complete the payment to continue.',
  'elementsInstructions.externalAction.mpesa_message_finish_payment_on_phone': 'An M-Pesa payment request has been sent to your phone.\nPlease complete the payment to continue.',
  'elementsInstructions.redirect.title': 'Complete your payment',
  'elementsInstructions.redirect.description': 'You will be taken to the partner\'s processing platform to complete this payment. Once it is done, you will be redirected to this page again.',
  'elementsInstructions.redirect.button': 'Make your payment',
  'documentCollector.collapsibleTitle': 'Upload Documentation',
  'documentCollector.uploadingDocument': 'Uploading document',
  'documentCollector.deleteFile': 'Delete {{fileName}}',
  'documentCollector.deletingFile': 'Deleting {{fileName}}',
  'documentCollector.moreInfoModal': 'More info',
  'documentCollector.errorsModal': 'Document warnings',
  'documentCollector.documentList': 'Document list',
  'documentCollector.upload': 'Upload',
  'documentCollector.errorBlockLabel': 'Document warnings',
  'documentCollector.reUpload': 'Re-upload',
  'documentCollector.errorsFoundOne': '{{count}} Warning Found',
  'documentCollector.errorsFoundOther': '{{count}} Warnings Found',
  'documentCollector.validationNote': '<b>File upload complete!</b> Our automated scan flagged potential issues. If your document contains all the required information, ignore this warning.',
  'documentCollector.antivirus': 'Antivirus File Scan',
  'documentCollector.antivirusStep': 'Antivirus File Scan 1/2',
  'documentCollector.verifyingStep': 'Verifying Documents 2/2',
  'documentCollector.invalidFile': 'Invalid file detected. The file may be password-protected or encrypted. Please verify and try again.',
  'documentCollector.moreInfo': 'More info',
  'documentCollector.required': 'Required',
  'documentCollector.review': 'Review',
  'documentCollector.acceptedFileTypes': 'Accepted file types: <b>PDF</b>, <b>PNG</b>, <b>JPG</b>',
  'documentCollector.maxFileSize': 'Maximum file size: <b>{{maxFileSize}}MB.</b>',
  'documentCollector.acceptedFileAndFileSize': 'Accepted file types: <b>PDF</b>, <b>PNG</b>, <b>JPG</b>. Maximum file size: <b>{{maxFileSize}}MB.</b>',
  'documentCollector.docVerifyError.missingInfo': 'Please check that the document contains all the requested info.',
  'documentCollector.docVerifyError.documentTypeError': 'This doesn\'t look like a {{documentType}}. Please check the requirements and upload a new file if necessary.',
  'documentCollector.docVerifyError.documentIdentificationTypeError': 'The uploaded document doesn\'t look like a {{documentType}}, which is the identification type you selected for this payment. Please check & re-upload if necessary.',
  'documentCollector.docVerifyError.documentType.errorNote': '<b>Note</b>: Submitting incorrect documents can cause delays in processing payment. If your documents are valid, please disregard this warning note.',
  'documentCollector.duplicateFile': 'Duplicate document detected. Please upload a different file for each.',
  'oneOff.savePaymentMethod.label': 'Save this payment method for future payments',
  'lrs.transaction.title': 'Transaction',
  'lrs.transaction.date': 'Date',
  'lrs.transaction.amount': 'Amount',
  'lrs.transaction.amountHint': 'Amount in foreign currency',
  'lrs.transaction.adBranch': 'Name and Address of AD branch',
  'lrs.transaction.add': 'Add more transactions',
  'lrs.signatureModal.title': 'Sign the document',
  'lrs.signatureModal.tab.draw': 'Draw signature',
  'lrs.signatureModal.tab.upload': 'Upload signature',
  'lrs.signatureModal.draw.text': 'Sign in the provided space below using your mouse or finger to accept the document.',
  'lrs.signatureModal.legalAlert': 'Invalid signatures will invalidate all the LRS process. Please, make sure to sign with the <b>PAN holder\'s signature</b>. A copy of the document will be sent to the provided payer email for your future needs. Accepted file types: <b>PNG</b>, <b>JPG</b>.',
  'lrs.signatureModal.draw.clear': 'Clear',
  'lrs.signatureModal.upload.label': 'Upload an image version of your signature',
  'lrs.signatureModal.upload.input': 'Upload signature',
  'lrs.signatureModal.upload.remove': 'Remove',
  'lrs.signatureModal.upload.hint': 'Accepted file types: <b>PNG</b>, <b>JPG</b>. Maximum file size: <b>8MB</b>',
  'lrs.signatureModal.upload.typeError': 'File type not supported. Please upload a PNG or JPG.',
  'lrs.signatureModal.upload.sizeError': 'File must be smaller than 8MB',
  'lrs.signatureModal.upload.readError': 'Could not read the file. Please try again.',
  'lrs.signatureModal.confirm': 'Accept and submit',
  'lrs.signatureModal.previewError': 'Something went wrong while generating the preview. Please try again.',
  'lrs.signatureModal.uploadError': 'Something went wrong while submitting. Please try again.',
  'lrs.previewLink.label': 'Preview document',
  'lrs.documents.continueButton': 'Continue to submit LRS form',
  'lrs.form.declaration': 'Under the Liberalised Remittance Scheme (LRS), the Indian government and the Reserve Bank of India (RBI) now require an LRS Declaration form (fully titled "A2 cum LRS Declaration") to transfer funds abroad. It is MANDATORY to submit your LRS Declaration before initiating your bank transfer, otherwise, your payment may experience delays in being processed. For more details on how to complete this step, click <a href=\'https://help.flywire.com/hc/en-us/articles/360012963774\' target=\'_blank\'>here</a> to learn more.',
  'lrs.form.bankAccountAndStudentInfo.title': 'Bank account and student info',
  'lrs.form.bankAccountAndStudentInfo.text': 'Please specify the bank account from which the funds will be transferred. If you have taken an education loan and the funds will be disbursed from your loan account, kindly provide the loan account number. Transfers from NRO/NRE accounts are not accepted. For Student ID, you may use your Student ID, Application ID, or Reference Number.',
  'lrs.form.details.title': 'Details of international transactions made in the current financial year',
  'lrs.form.details.text': 'Please provide the details of any foreign currency transactions you have made during the current financial year (<b>April {{startYear}} - March {{endYear}}</b>). Leave blank if you have not made any.',
  'lrs.form.bankAccountNumber': 'Bank Account Number',
  'lrs.form.studentFullName': 'Student Full Name',
  'lrs.form.studentId': 'Student ID',
  'lrs.form.required': 'Required',
  'lrs.form.signAndSubmit': 'Sign & Submit LRS form',
  'lrs.title': 'Upload documentation and submit LRS form',
  'lrs.description': 'You will see the bank transfer payment instructions once this step is completed.',
  'lrs.tabs.documents': '1. Upload documents',
  'lrs.tabs.form': '2. Submit LRS form',
  'recipientFields.requiredField': '(*) required field',
  'paymentMethodSelector.loading': 'Loading payment methods...',
  'paymentMethodSelector.cards.acceptsDebitAndCredit': 'Accepts debit and credit cards',
  'paymentMethodSelector.cards.acceptsDebitOnly': 'Accepts debit cards',
  'paymentMethodSelector.cards.acceptsCreditOnly': 'Accepts credit cards',
  'paymentMethodSelector.cards.surchargeWarning': 'Surcharges may apply depending on card type and issuing country.',
  'paymentMethodSelector.subtitle.default': 'Pay with {{methodName}}',
  'paymentMethodSelector.subtitle.google_pay': 'Pay with your saved Google Pay wallet',
  'paymentMethodSelector.subtitle.apple_pay': 'Touch ID or Face ID — Safari only',
  'paymentMethodSelector.subtitle.paypal': 'Pay with your PayPal account',
  'paymentMethodSelector.subtitle.wechat': 'Pay with WeChat — available in mainland China',
  'paymentMethodSelector.subtitle.alipay': 'Pay with Alipay',
  'paymentMethodSelector.subtitle.trustly': 'Open banking payment'
} as const;
export { enUS };
